/**
 * Copyright © 2026 OwnersTable Inc. All rights reserved.
 * This source code is proprietary and confidential.
 * Unauthorized copying or distribution is strictly prohibited.
 */

import { styled, Chip } from "@mui/material";

export const StatusChipContainer = styled('div')({
  marginTop: '10px',
})

export const StyledStatusChip = styled(Chip, {
	shouldForwardProp: (prop) => prop !== 'isActive',
})(({ isActive }) => ({
	height: '22px',
	borderRadius: '999px',
	backgroundColor: isActive === 'active' ? '#dff8eb' : '#eceff3',
	color: isActive === 'active' ? '#11a95f' : '#64748b',
	'& .MuiChip-label': {
		paddingLeft: '8px',
		paddingRight: '8px',
		fontSize: '10px',
		fontWeight: 700,
		lineHeight: 1,
	},
}));
